import React from 'react';
import { H2 } from 'design-system';

interface SectionTitleProps {
  icon?: React.ReactNode;
  title: string;
  children?: React.ReactNode;
}

export default class SectionTitle extends React.Component<SectionTitleProps> {
  render() {
    return (
      <div className="header">
        <div className="title">
          <H2>
            {this.props.icon} {this.props.title}
          </H2>
        </div>
        <div>{this.props.children}</div>
        <style jsx>{`
          .header {
            flex-shrink: 0;
            margin-bottom: 24px;

            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
        `}</style>
      </div>
    );
  }
}
